import { useState, useEffect } from 'react';

interface GameState {
  globalAttemptCount: number;
  currentAttemptCost: number;
}

export const useGameState = () => {
  const [gameState, setGameState] = useState<GameState>({
    globalAttemptCount: 0,
    currentAttemptCost: 0.01 // Default to initial price
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchGameState = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/game/state`);
        if (!response.ok) {
          throw new Error('Failed to fetch game state');
        }
        const data = await response.json();
        setGameState(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load game state');
        console.error('Error fetching game state:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchGameState();
  }, []);

  return { gameState, loading, error };
}; 